if (!customElements.get('gpg-carousel-settings')) {
  customElements.define('gpg-carousel-settings', class extends HTMLElement {
    connectedCallback() {
      this.carousel = this.closest('slider-component');
      this.track = this.carousel?.querySelector('[id^="Slider-"]');
      if (!this.track) return;
      this.update = () => {
        const slides = [...this.track.querySelectorAll('[id^="Slide-"]')];
        if (!slides.length) return;
        const trackBox = this.track.getBoundingClientRect();
        const visible = slides.filter(slide => {
          const box = slide.getBoundingClientRect();
          return box.left >= trackBox.left - 2 && box.right <= trackBox.right + 2;
        });
        const step = Math.max(1, visible.length);
        this.carousel.querySelectorAll('button[name="previous"],button[name="next"]').forEach(button => { button.dataset.step = String(step); });
        const first = visible[0] || slides.find(slide => slide.getBoundingClientRect().right > trackBox.left + 2);
        const last = visible[visible.length - 1] || first;
        const status = this.carousel.querySelector('[data-gpg-range]');
        if (status && first && last) {
          const template = first === last ? status.dataset.gpgSingle : status.dataset.gpgRange;
          status.textContent = template.replace('__GPG_FIRST__', String(slides.indexOf(first) + 1)).replace('__GPG_LAST__', String(slides.indexOf(last) + 1));
        }
      };
      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
